module.exports = __webpack_public_path__ + "img/ad_main1.e9a42b99.png";